import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import ColumnContainer from '../../components/layouts/components/column-container';
import { useOnlineStatus } from '../../lib/hooks';
import Notification from '../../components/notification';
import { Body } from '../../components/typography';

const AnimationWrapper = styled.div`
    max-width: 100%;

    ${(props) => props.theme.mediaQueries.desktop} {
        max-width: calc(100% / 3);
    }

    & > div {
        animation-name: translate;
        animation-duration: 1s;
        animation-fill-mode: forwards;
        animation-timing-function: cubic-bezier(0.25, 0.1, 0.25, 1);
    }

    @keyframes translate {
        0% {
            transform: translateY(-150px);
        }
        100% {
            transform: translateY(0);
        }
    }
`;

export const NotificationContainer = ({ finished, updateStatusError, visibleModal, bottom }) => {
    const onlineStatus = useOnlineStatus();

    return (
        <ColumnContainer
            position="absolute"
            justifyContent={['center', 'center', 'flex-end']}
            paddingY="small"
            paddingX={['mobile', 'tablet', 'desktop']}
            zIndex={1}
            bottom={bottom}
            style={{ pointerEvents: 'none' }}
        >
            {!visibleModal && (
                <AnimationWrapper>
                    {!onlineStatus && (
                        <Notification>
                            <Body color="white" lv={4}>
                                <div>
                                    <strong>{'Sei online? '}</strong>
                                    {'Controlla la connessione per svolgere la prova.'}
                                </div>
                            </Body>
                        </Notification>
                    )}

                    {updateStatusError && onlineStatus && !finished && (
                        <Notification>
                            <Body color="white" lv={4}>
                                <div>
                                    <strong>{'Attenzione! '}</strong>

                                    {
                                        'C’è un problema temporaneo con il salvataggio. Puoi continuare a svolgere gli esercizi, ma aspetta che questo messaggio sparisca prima di mettere in pausa o terminare la prova.'
                                    }
                                </div>
                            </Body>
                        </Notification>
                    )}
                </AnimationWrapper>
            )}
        </ColumnContainer>
    );
};

NotificationContainer.propTypes = {
    finished: PropTypes.bool,
    updateStatusError: PropTypes.bool,
    visibleModal: PropTypes.bool,
    bottom: PropTypes.array,
};

const mapStateToProps = (state) => {
    return {
        finished: state.status.finished,
        updateStatusError: !!state.status.httpStatus.errorbody,
        visibleModal: state.modal.visible,
    };
};

export default connect(mapStateToProps)(NotificationContainer);
